<template>
  <div class="footer">
    <div class="wrapper">
      <el-row :gutter="30" class="content">
        <el-col :span="3" class="list" v-for="(item,index) in list" :key="index">
          <ul>
            <li @click="goList(item.url_index)">{{ item.name }}</li>
            <li v-for="(ele,index) in item.child_list" :key="index" @click="goItem(ele.url_index,ele.id)">
              {{ele.name}}
            </li>
          </ul>
        </el-col>
        <el-col :span="3" class="list">
          <div class="box">
            <img :src="gzh_img" alt="">
          </div>
        </el-col>
        <el-col :span="12" class="list">
          <ul>
            <li>全国统一免费咨询热线</li>
            <li>010-68888687</li>
            <li>邮箱：public@zisonai.com</li>
            <li>地址：北京石景山区城通街26号院2号楼12层1222-1224房</li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="copyright">
      Copyright 2019 北京智胜远景科技有限公司 版权所有 All Rights Reserved<br> 
      
      <span>增值电信业务经营许可证: 京B2-20231920</span> |
      <a class="bot" target="_blank" href="https://beian.miit.gov.cn/">京ICP备19054919号</a> |
      <img src="../assets/images/备案号.png" alt="" />
      <span>京公网安备11010702001941号</span> 
    </div>
  </div>
</template>

<script>
import url from "../api/baseurl";
export default {
  data() {
    return {
      gzh_img:'',
      list:[]
    }
  },
  created () {
    this.getData();
  },
  mounted() {
    // 获取企业介绍列表
    this.introductionList({type:3})
  },
  methods: {
      // 获取企业介绍列表
      introductionList(params){
          this.$api.aboutList(params).then(res=>{
          this.gzh_img=url + res.data.data.list[0].gzh_img
        })
    },
    goItem(url,id){
      this.$router.push(url+'/'+id)
    },
    goList(url){
      this.$router.push(url)
    },
    async getData() {
      let res = await this.$api.getData();
      let arr= res.data.menu_list;
      arr.forEach((ele)=>{
        if (ele.child_list&&ele.child_list.length>0) {
          this.list.push(ele)   
        }
      })
  },
}
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 1200px) {
  .bot{
    color: #666;
    &:hover{
      color: #fff;
    }
  }
  .footer {
    // background-color: #3777ff;
    background-color: #303036;
    padding-top: 0.3rem;
    margin-top: 50px;
    .wrapper {
      width: 12rem;
      // height: 2.1rem;
      margin: 0 auto;
      margin-bottom: 30px;
      .content {
        ul {
          li {
            padding-bottom: 0.05rem;
            color: #999;
            &:first-child {
              color: #fff;
              padding-bottom: 0.15rem;
              font-size: 16px;
              &:hover {
                cursor: pointer;
              }
            }
            a{
              color: #999;
            }
          }
          &:hover {
            cursor: pointer;
          }
        }
        .list:last-child {
          // background-color: black;
          ul {
            padding-left: 130px;
            li {
              color: #e2e6ea;
              &:first-child {
                color: #fff;
              }
            }
            &:hover {
              cursor: text;
            }
          }
          ul > li:first-child,
          ul > li:nth-child(2) {
            font-size: 30px;
          }
        }

        .box {
          margin-top: 20px;
          width: 100px;
          height: 100px;
          img{
            width: 100px;
            height: 100px;
          }
        }
      }
    }
    .copyright {
      width: 100%;
      background-color: #222;
      color: #666;
      text-align: center;
      font-size: 12px;
      padding-top: 0.1rem;
      padding-bottom: 0.1rem;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .bot{
    color: #000;
    &:hover{
      color: #fff;
    }
  }
  .footer {
    width: 100%;
    background-color: #303036;
    margin-top: 0.2rem;
    padding-top: 0.05rem;
    padding-left: 0.06rem;
    padding-right: 0.02rem;
    .wrapper {
      width: 4rem;
      // height: 1.1rem;
      // background-color: #a8c8e9e8;
      margin: 0 auto;
      padding: 0.1rem 0.05rem 0 0.05rem;
      .content {
        ul {
          li {
            width: 50rem;
            font-size: 0.05rem;
            padding-bottom: 0.03rem;
            height: 0.1rem;
            color: #fff;
            &:first-child {
              padding-bottom: 0.05rem;
              font-size: 0.06rem;
            }
          }
        }
        .list:last-child {
          ul {
            padding-left: 0.05rem;
          }
          ul > li:first-child,
          ul > li:nth-child(2) {
            font-size: 0.1rem;
          }
        }

        .box {
          margin-top: 0.1rem;
          width: 0.5rem;
          height: 0.5rem;
          // background-color: #fff;
          margin-left: -0.09rem;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .copyright {
      text-align: center;
      padding-top: 0.1rem;
      padding-bottom: 0.1rem;
      font-size: 0.05rem;
      line-height: 0.1rem;
      img{
        width: 0.05rem;
        height: 0.05rem;
      }
    }
  }
}
</style>